import { createContext } from 'react';
import { ContextWrapper } from '../../config/constants';
import { PoolActions, PoolStateType } from './poolTypes';

const poolContext = createContext({} as ContextWrapper<PoolStateType, PoolActions>);
poolContext.displayName = 'PoolContext';

export default poolContext;
